import IconV2 from '@/components/v2/IconV2';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

const TableHeader = ({ columns, onSort, sortConfig, hasActions = false }) => {
  return (
    <div className={'table-header'}>
      {columns
        .filter((c) => !!c?.width)
        .map((column, index) => (
          <div key={index} className={`table-cell ${sortConfig?.key === column.key ? 'sorted' : ''}`} style={{ ...column.style, width: column.width, cursor: column.sortable ? 'pointer' : 'default' }} onClick={() => column.sortable && onSort?.(column.key)}>
            {column.label}
            {column.sortable && sortConfig?.key === column.key && <IconV2 icon={sortConfig?.direction === 'ascending' ? FaCaretUp : FaCaretDown} className={'light-medium'} />}
          </div>
        ))}
      {hasActions && <div className={'table-cell actions-cell'} aria-hidden={'true'} />}
    </div>
  );
};

export default TableHeader;
